/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import { Radio, RadioGroup } from '@coursera/cds-core';

import type { CreateReportScopeKey } from 'bundles/enterprise-admin-drawers/utils/EnterpriseEmailReportsAPIUtils';

import _t from 'i18n!nls/enterprise-admin-drawers';

type PropsFromCaller = {
  reportScope?: CreateReportScopeKey;
  handleChange: (e: CreateReportScopeKey) => void;
};

const UsageReportScopeSelector = ({ reportScope, handleChange }: PropsFromCaller) => {
  return (
    <RadioGroup
      onChange={(e) => handleChange(e.target.value as CreateReportScopeKey)}
      value={String(reportScope)}
      aria-label={_t('Select data to include')}
      css={{ marginBottom: 'var(--cds-spacing-400)' }}
      data-testid="usage-report-scope-selector-radio-group"
    >
      <Radio
        value="allActive"
        // @ts-expect-error: next-line
        label={<FormattedHTMLMessage message={_t('Include data from <strong>all active contracts</strong>')} />}
      />
      <Radio
        value="allBillable"
        // @ts-expect-error: next-line
        label={
          <FormattedHTMLMessage
            message={_t(
              'Include data from <strong>all active contracts and expired billable contracts (exclude non-billable expired contracts)</strong>'
            )}
          />
        }
      />
      <Radio
        value="all"
        // @ts-expect-error: next-line
        label={
          <FormattedHTMLMessage
            message={_t(
              'Include data from <strong>all contracts (active and expired billable and non-billable contracts)</strong>'
            )}
          />
        }
      />
    </RadioGroup>
  );
};

export default UsageReportScopeSelector;
